import type { SidePanel } from '../types';

export const NotifyDialog: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./NotifyDialogPanel.vue')),
};
